import { render, staticRenderFns } from "./InformationCertification.vue?vue&type=template&id=1377e17e&scoped=true"
import script from "./InformationCertification.vue?vue&type=script&lang=js"
export * from "./InformationCertification.vue?vue&type=script&lang=js"
import style0 from "./InformationCertification.vue?vue&type=style&index=0&id=1377e17e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1377e17e",
  null
  
)

export default component.exports